module.exports = __webpack_public_path__ + "img/Villa_Borna_4.eaf063a9.jpg";